const isVisible = (elem) => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

const hideOnClickOutside = (element) => {
  const outsideClickListener = (event) => {
    const removeClickListener = () => {
      document.removeEventListener('click', outsideClickListener);
    };
    if (!element.contains(event.target)) {
      if (isVisible(element)) {
        element.classList.remove('is-active');
        removeClickListener();
      }
    }
  };

  document.addEventListener('click', outsideClickListener);
};

const showHide = (selector) => {
  const remotes = selector ? document.querySelectorAll(selector) : document.querySelectorAll('[data-toggle="show-hide"]');

  remotes.forEach((remote) => {
    remote.addEventListener('click', (e) => {
      const element = e.currentTarget;

      if (element.dataset.target === 'parent') {
        element.parentNode.classList.toggle('is-active');
        return false;
      }

      if (element.dataset.hideOnOutclick) {
        hideOnClickOutside(element);
      }

      const target = document.querySelector(element.dataset.target);

      element.classList.toggle('is-active');

      if (target) {
        target.classList.toggle('is-active');
      }

      return false;
    });
  });
};

export default showHide;



// WEBPACK FOOTER //
// ./resources/assets/js/functions/showhide.js